import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type PageType } from '@blaze-shared/api-contracts-domain';
import { type PregenerationType } from '@blaze-shared/elements-domain';

export const tryCreateRowActionPage = createAction(
  '[Row Action Generation] Try create row action page',
  props<{
    elementId: CanvasElementId;
    pregenerationType: PregenerationType;
    pageType: PageType;
    actionPath: string;
    forceCreate?: boolean;
  }>(),
);

export const createRowActionPage = createAction(
  '[Row Action Generation] Create row action page',
  props<{
    name: string;
    elementId: CanvasElementId;
    pregenerationType: PregenerationType;
    pageType: PageType;
    actionPath: string;
  }>(),
);

export const createRowActionPageSuccess = createAction(
  '[Row Action Generation] Create row action page success',
  props<{
    name: string;
    elementId: CanvasElementId;
    actionPath: string;
    pregenerationType: PregenerationType;
    pageType: PageType;
  }>(),
);

export const createRowActionPageFailure = createAction(
  '[Row Action Generation] Create row action page failure',
  props<{
    elementId: CanvasElementId;
    actionPath: string;
    pregenerationType: PregenerationType;
    pageType: PageType;
    error?: string;
  }>(),
);
